import { React, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faDashboard,
  faSitemap,
} from "@fortawesome/free-solid-svg-icons";
import { Collapse } from "react-bootstrap";
import { NavLink } from "react-router-dom";
const Sidebar = (props) => {
  const [para, setpara] = useState(false);
  const [close, setclose] = useState(false);

  return (
    <>
      <aside id="sidebar-wrapper">
        <div className="sidebar mt-4">
          <nav className="navigation">
            <ul className="mainmenu">
              <li>
                <NavLink to="/dashboard" onClick={props.toggleClass}>
                  <span>
                    <FontAwesomeIcon
                      icon={faDashboard}
                      className="dropdown_icon"
                    />
                  </span>
                  Dashboard
                </NavLink>
              </li>
            </ul>
            <hr style={{ width: "85%", height: "2px", marginLeft: "7%" }} />
            <ul className="main-submenu">
              <li>
                <span>
                  <FontAwesomeIcon
                    icon={faSitemap}
                    className="dropdown_icon"
                    style={{ color: "white" }}
                  />
                </span>
                <label onClick={() => setpara(!para)} aria-expanded={para}>
                  Master
                  <small className="right-side-set-arrow">
                    <FontAwesomeIcon
                      icon={para ? faChevronUp : faChevronDown}
                      className="dropdown_icon"
                    />
                  </small>
                </label>

                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="news/list" onClick={props.toggleClass}>
                      <li> News</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/product/list" onClick={props.toggleClass}>
                      <li> Product</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/manual/list" onClick={props.toggleClass}>
                      <li> Manual</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/brochure/list" onClick={props.toggleClass}>
                      <li> Brochure</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/tutorial/list" onClick={props.toggleClass}>
                      <li> Tutorial</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/career/list" onClick={props.toggleClass}>
                      <li> Career</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink
                      to="/thematicdemo/list"
                      onClick={props.toggleClass}
                    >
                      <li> TheMaticDemo</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/contact/list" onClick={props.toggleClass}>
                      <li> Contact</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/software/list" onClick={props.toggleClass}>
                      <li> Software</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/newsletter/list" onClick={props.toggleClass}>
                      <li> News Letter</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/topic/list" onClick={props.toggleClass}>
                      <li>Topic</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink
                      to="/newslettermail/list"
                      onClick={props.toggleClass}
                    >
                      <li>News Letter Mail</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/topicitem/list" onClick={props.toggleClass}>
                      <li>Topic Item</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/quote/list" onClick={props.toggleClass}>
                      <li>Quote</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={para} className="p-0">
                  <ul className="submenu">
                    <NavLink to="blog/list" onClick={props.toggleClass}>
                      <li> Blog</li>
                    </NavLink>
                  </ul>
                </Collapse>
              </li>
              <li>
                <span>
                  <FontAwesomeIcon
                    icon={faSitemap}
                    className="dropdown_icon"
                    style={{ color: "white" }}
                  />
                </span>
                <label onClick={() => setclose(!close)} aria-expanded={close}>
                  Settings
                  <small className="right-side-set-arrow">
                    <FontAwesomeIcon
                      icon={close ? faChevronUp : faChevronDown}
                      className="dropdown_icon"
                    />
                  </small>
                </label>
                <Collapse in={close} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/features/list" onClick={props.toggleClass}>
                      <li>Features</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={close} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/our-product/list" onClick={props.toggleClass}>
                      <li>Our Product</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={close} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/testimonial/list" onClick={props.toggleClass}>
                      <li>Testimonial</li>
                    </NavLink>
                  </ul>
                </Collapse>
                <Collapse in={close} className="p-0">
                  <ul className="submenu">
                    <NavLink to="/general-setting/list" onClick={props.toggleClass}>
                      <li>General Settings</li>
                    </NavLink>
                  </ul>
                </Collapse>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};
Sidebar.propTypes = {
  toggleClass: PropTypes.any.isRequired,
};

export { Sidebar };
